export const ListQueryKey = 'bankcards';
export const DetailQueryKey = 'bankcard';
export const Urls = {
  selectUrl: '/bankcard/list',
  updateUrl: '/bankcard/update',
  deleteUrl: '/bankcard/delete',
  batchDeleteUrl: '/bankcards/delete',
  createUrl: '/bankcard/create',
  detailUrl: '/bankcard/detail'
};